export default {
  apiServerUrl: 'https://petfish8.devsafi.pl', // 'https://pet-fish.co.uk',
  googleMapsApiKey: ''
};
